import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'app-address-info',
    templateUrl: './address-info.component.html',
    styleUrls: ['./address-info.component.scss'],
    standalone: false
})
export class AddressInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}


